import { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import { MyAccountPlaceholder } from '@r-and-a-shared-ui/common-ui';

export default {
  component: ()=>MyAccountPlaceholder,
  mapEntryToProps: (entry: MEMBERSHIP_MODELS.MyAccountPlaceholder) =>
    kontentAiDataMapping.my_account_placeholder(entry),
};
